import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class FacebookPixelService {
    private get fbq() {
        if (typeof (window as any).fbq !== "function") {
            console.warn("Facebook Pixel (fbq) not loaded.");
            return null;
        }
        return (window as any).fbq;
    }

    viewContent(
        content_category: string,
        content_name: string,
        content_type: string,
        value: number,
        content_ids: string[],
        current_lesson?: string
    ): void {
        const fbq = this.fbq;
        if (!fbq) return;

        fbq("track", "ViewContent", {
            content_category: content_category,
            content_name: content_name,
            content_type: content_type,
            value: value,
            currency: "BRL",
            current_lesson: current_lesson,
            content_ids: content_ids
        });
    }

    AddPaymentInfo(content_category: string, contents: any): void {
        const fbq = this.fbq;
        if (!fbq) return;

        fbq("track", "AddPaymentInfo", {
            contents: contents,
            content_category: content_category,
            currency: "BRL",
            value: 0 // Optional but recommended if known
        });
    }

    CompleteRegistration(status: boolean, content_name: string, content: any): void {
        const fbq = this.fbq;
        if (!fbq) return;

        fbq("track", "CompleteRegistration", {
            content_name: content_name,
            status: status,
            content: content
        });
    }

    Contact(): void {
        const fbq = this.fbq;
        if (!fbq) return;
        fbq("track", "Contact");
    }

    InitiateCheckout(
        content_name: string,
        content_category: string,
        content_ids: string[],
        value: number,
        currency = "BRL"
    ): void {
        const fbq = this.fbq;
        if (!fbq) return;

        fbq("track", "InitiateCheckout", {
            content_name: content_name,
            content_category: content_category,
            content_ids: content_ids,
            currency: currency,
            value: value
        });
    }

    Purchase(content_name: string, content_type: string, currency: string, value: number, content: any): void {
        const fbq = this.fbq;
        if (!fbq) return;

        fbq("track", "Purchase", {
            content_name: content_name,
            content_type: content_type,
            currency: currency,
            value: value,
            content: content
        });
    }

    Search(content_category: string, search_string: string, userEmail?: string): void {
        const fbq = this.fbq;
        if (!fbq) return;

        fbq("track", "Search", {
            content_category: content_category,
            search_string: search_string,
            userEmail: userEmail // Note: Sending PII (email) in parameters is discouraged unless hashed
        });
    }

    freeCourseRegistration(courseName: string, courseId: string, email: string, userName: string): void {
        const fbq = this.fbq;
        if (!fbq) return;

        fbq("trackCustom", "FreeCourseRegistration", {
            courseName: courseName,
            courseId: courseId,
            email: email, // PII
            userName: userName // PII
        });
    }

    Login(email: string, usernames: string[], name: string, mothod?: string): void {
        const fbq = this.fbq;
        if (!fbq) return;

        fbq("trackCustom", "Login", {
            email: email, // PII
            username: usernames,
            name: name, // PII
            mothod: mothod
        });
    }

    grantConsent(): void {
        const fbq = this.fbq;
        if (!fbq) return;
        fbq("consent", "grant");
    }

    revokeConsent(): void {
        const fbq = this.fbq;
        if (!fbq) return;
        fbq("consent", "revoke");
    }

    trackPageView(): void {
        const fbq = this.fbq;
        if (!fbq) return;
        fbq("track", "PageView");
    }
}
